import { BreakpointArray } from '@thg-commerce/gravity-theme'
import {
  PaddingInterface,
  MarginInterface,
} from '@thg-commerce/enterprise-widget-editorial/theme'

export type ItemAlignmentType = 'initial' | 'center'
export interface ContainerInterface {
  gap: BreakpointArray<number>
  itemAlignment: ItemAlignmentType
}

export interface CategorySetThemeInterface {
  sixItemCategory: {
    gutterPadding: PaddingInterface
    container: ContainerInterface
    gutterMargin: MarginInterface
    contentGutterPadding: PaddingInterface
  }
  multiCategory: {
    gutterPadding: PaddingInterface
    container: ContainerInterface
    gutterMargin: MarginInterface
    contentGutterPadding: PaddingInterface
  }
}

export const CategorySetTheme: CategorySetThemeInterface = {
  sixItemCategory: {
    gutterPadding: {
      top: [0, 0, 2],
      right: [0],
      bottom: [0, 0, 2],
      left: [0],
    },
    container: {
      itemAlignment: 'center',
      gap: [2, 4],
    },
    gutterMargin: {
      top: [1, 1, 0],
      right: [2, 2, 'auto', 'auto'],
      bottom: [1, 1, 0],
      left: [2, 2, 'auto', 'auto'],
    },
    contentGutterPadding: {
      top: [0],
      right: [2],
      bottom: [3],
      left: [2],
    },
  },
  multiCategory: {
    gutterPadding: {
      top: [0, 0, 2],
      right: [0],
      bottom: [0, 0, 2],
      left: [0],
    },
    container: {
      itemAlignment: 'center',
      gap: [2, 4],
    },
    gutterMargin: {
      top: [1, 1, 0],
      right: [2, 2, 'auto'],
      bottom: [1, 1, 0],
      left: [2, 2, 'auto'],
    },
    contentGutterPadding: {
      top: [0],
      right: [2],
      bottom: [3],
      left: [2],
    },
  },
}
